export const cartHasRounding = (features: Record<string, boolean>) =>
  features.RoundDownToQuarter ||
  features.RoundDownToDollar ||
  features.RoundPercentDiscounts ||
  features.RoundToNearestNickel ||
  features.RoundToNearestDollar ||
  features.RoundDownToNearestFiver ||
  features.CurbsideRoundDownToNearestFiver;
